import clsx from 'clsx';
import Loader from 'components/Loader';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { useBrandContext } from 'context/BrandProvider';
import { useAuthUser } from 'hooks/useAuthUser';
import { FC } from 'react';
import Restore, { RestoreProps } from './Restore';
import SwitchToActiveGroup from './SwitchToActiveGroup';
import { usePermissions } from 'hooks/usePermissions';
import { useFormContext } from 'react-hook-form';

interface DesignerSidebarFooterProps extends RestoreProps {
  success: boolean;
  loading: boolean;
  onClose: () => void;
}

const DesignerSidebarFooter: FC<DesignerSidebarFooterProps> = ({
  success,
  loading,
  onClose,
  onRestoreSuccess,
  brandId,
}) => {
  const { brand } = useBrandContext();
  const { group_id } = useAuthUser();
  const { isSuperAdmin } = usePermissions();
  const {
    formState: { isDirty },
  } = useFormContext();
  if (
    process.env.REACT_APP_CURRENT_ENV === 'dev' &&
    isSuperAdmin &&
    brand?.groupId &&
    brand.groupId !== group_id
  ) {
    return <SwitchToActiveGroup />;
  }

  return (
    <div className="flex flex-col gap-4 pr-6">
      <div className="flex gap-2">
        <GraniteButton
          variant="secondary"
          size="large"
          className="!min-h-[40px] w-full"
          onClick={onClose}
        >
          Cancel
        </GraniteButton>
        <GraniteButton
          size="large"
          className={clsx(
            'flex !min-h-[40px] w-full min-w-[132px] items-center justify-center',
            {
              '!px-0': success,
            },
          )}
          disabled={loading}
          type="submit"
        >
          <span className="whitespace-nowrap">
            {success && !loading && !isDirty ? 'Changes saved' : 'Save'}
          </span>
          {loading ? <Loader width="w-5" height="h-5" /> : null}
        </GraniteButton>
      </div>
      <Restore brandId={brandId} onRestoreSuccess={onRestoreSuccess} />
    </div>
  );
};

export default DesignerSidebarFooter;
